<template>
  <div>
    <v-card>
      <v-card-title>
        Locations Visited
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-card-text>
        <v-timeline align-top dense>
          <v-timeline-item
            v-for="location in filteredLocations"
            :key="location.id"
            color="primary"
            small
          >
            <template v-slot:opposite>
              <span class="caption font-weight-bold">{{ location.date }}</span>
            </template>
            <v-card class="elevation-2">
              <v-card-title class="text-h6">
                {{ location.address }}
              </v-card-title>
              <v-card-subtitle>
                Lat: {{ location.latitude }}, Long: {{ location.longitude }}
              </v-card-subtitle>
              <v-card-text>
                <div class="text-caption grey--text">
                  <strong>Date:</strong> {{ location.date }} | <strong>Time:</strong> {{ location.time }}
                </div>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      locations: [],
    }
  },
  computed: {
    // Basic search filtering for the timeline
    filteredLocations() {
      if (!this.search) return this.locations
      const query = this.search.toLowerCase()
      return this.locations.filter(loc => 
        (loc.address && loc.address.toLowerCase().includes(query)) ||
        (loc.date && loc.date.toLowerCase().includes(query)) ||
        (loc.time && loc.time.toLowerCase().includes(query))
      )
    }
  },
  mounted() {
    this.fetchLocationData()
  },
  methods: {
    fetchLocationData() {
      fetch("https://api.tickettoghana.co.za/get-locations")
        .then(response => response.json())
        .then(locations => {
          if (!locations || locations.length < 1) return

          // 1. Sort by ID (ascending order)
          locations.sort((a, b) => b.id - a.id)

          // 2. Map the data structure
          this.locations = locations.map(location => {
            const dateParts = location.created_at ? location.created_at.split("T") : ['', '']
            return {
              id: location.id,
              date: dateParts[0],
              time: dateParts[1],
              address: location.address,
              latitude: location.latitude,
              longitude: location.longitude,
            }
          })
        })
        .catch(err => console.error("Error fetching locations:", err))
    }
  }
}
</script>

<style scoped>
/* Table striping styles removed since we are using v-timeline */
</style>